import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { messageListLoadEpicReducer } from "./messageList.duck.js";
import { reduxActionTypePrefix, reduxKeys } from "../constants/constants.js";
import MessagesResource from "../resources/Messages.resource.js";
const actionTypesPrefix = reduxActionTypePrefix + "/dismissMessage";
const messageDismissEpicReducerArg = {
  actionPrefix: actionTypesPrefix,
  reduxKeyNested: () => [reduxKeys.value],
  loadResource: (request) => MessagesResource.dismissMessage(request.workspaceId, request.messageId),
  onCompleteSuccess: (dismissResult, inputPayload) => (dismissResult == null ? void 0 : dismissResult.Value) || 0,
  afterActionsOnSuccess: (inputPayload, outputPayload) => loadMessagesAndRefreshCount(inputPayload, outputPayload)
};
const messageDismissEpicReducer = loadResourcesUtils(messageDismissEpicReducerArg);
const loadMessagesAndRefreshCount = (inputPayload, outputPayload) => [
  messageListLoadEpicReducer.actionCreators.load({
    workspaceId: inputPayload.workspaceId,
    loadCount: inputPayload.loadCount,
    needNewMessage: false,
    lastMessageId: inputPayload.lastMessageId
  })
];
const messageDismissReducerStateDefault = {
  value: getDefaultAsyncWrapperObj()
};
const messageDismissReducer = (state = messageDismissReducerStateDefault, action) => {
  state = messageDismissEpicReducer.reduxChange(state, action);
  return state;
};
export {
  messageDismissReducer as default,
  messageDismissEpicReducer,
  messageDismissReducer,
  messageDismissReducerStateDefault
};
//# sourceMappingURL=messageDismiss.duck.js.map
